import { render, staticRenderFns } from "./VendorNew_Details.vue?vue&type=template&id=08b51821&"
import script from "./VendorNew_Details.vue?vue&type=script&lang=js&"
export * from "./VendorNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports